import { Landmark } from "lucide-react";
import type { DashboardTarget } from "@/lib/api/dashboard";
import { useDashboardWidget } from "@/lib/hooks/use-dashboard";
import { useT } from "@/lib/i18n/use-t";
import { useDashboardFormat } from "../use-dashboard-format";
import { KeyFigureValue } from "./key-figure-value";
import { StatsCard } from "./stats-card";
import { T } from "./total-aum-widget.i18n";

export function TotalAumWidget({ target }: { target: DashboardTarget }) {
  const { data, isLoading, error } = useDashboardWidget("total_aum", target);
  const t = useT(T);
  const { compactMoney } = useDashboardFormat();
  return (
    <StatsCard
      icon={Landmark}
      label={t.totalAum}
      value={
        <KeyFigureValue isLoading={isLoading} error={error}>
          {data && compactMoney(data.amount, data.currency)}
        </KeyFigureValue>
      }
      subtitle={t.aumSubtitle}
    />
  );
}
